import React from 'react'
import * as firebase from 'firebase'

import ActionSchedule from 'material-ui/svg-icons/action/schedule'
import { TargetModule } from '../text/TextModules.js'
import JobModuleBase from '../JobModuleBase'

export default class ClockJobExtendedModule extends JobModuleBase {

  constructor(props) {
    super(props)
    this.state = {
      moduleInfo: undefined
    }
  }

  getCurrentDayClockingsDbPath = () => {
    return `${this.getExtendedModulesDbPath()}/${this.props.dateStr}`
  }

  componentWillMount() {
    firebase
      .database()
      .ref(this.getCurrentDayClockingsDbPath())
      .on('value', this.onUpdate)
  }

  componentWillUnmount() {
    firebase
      .database()
      .ref(this.getCurrentDayClockingsDbPath())
      .off('value', this.onUpdate)
  }

  onUpdate = (snapshot) => {
    this.setState({
      clockingInfo: snapshot.val()
    })
  }

  getModuleInfo() {
    return this.state.clockingInfo
  }

  updateShifts() {
    this.shifts = []

    this.shifts.push({
      index: 0,
      timeIn: this.getModuleInfo().timeIn,
      timeOut: this.getModuleInfo().timeOut
    })

    const allShifts = this.getModuleInfo().shifts
    if (allShifts) {
      for (const key in allShifts) {
        if (allShifts[key]._type === 'deleted') {
          continue
        }

        this.shifts.push(allShifts[key]);
        this.shifts[this.shifts.length - 1].index = this.shifts.length - 1;
      }
    }
  }

  renderShift(shift) {
    return (
      <div
        key={shift.index}
        className="horizontal-container">
        <ActionSchedule
          style={{ marginTop: 6, width: 20, height: 20, color: '#adadad' }}/>
        <span
          style={{ margin: 8 }}
          className="field-label">
          {
            (shift.timeIn ? shift.timeIn : '')
            + ' - ' +
            (shift.timeOut ? shift.timeOut : '')
          }
        </span>
      </div>
    )
  }

  renderShifts() {
    if (!this.getModuleInfo()) {
      return null
    }
    this.updateShifts()
    if (this.shifts.length === 0) {
      return null
    }
    return (
      <div style={styles.shiftContainer}>
        {this.shifts.map(shift => this.renderShift(shift))}
      </div>
    )
  }

  render() {
    return (
      <div style={styles.container}>
        { this.renderShifts() }
        { this.props.jobInfo.modules.clockingExtended.target === undefined
          ? null 
          : <div style={{ width: 150 }}>
            <TargetModule
              moduleName='clockingExtended'
              dbPath={this.getCommonModulesDbPath()}
              jobInfo={this.props.jobInfo}/>
          </div>
        }
      </div>
    )
  }
}

const styles = {

  container: {
    display: 'flex',
    flexDirection: 'column'
  },

  shiftContainer: {
    marginBottom: 8
  }

}



// WEBPACK FOOTER //
// ./src/schedule/common/modules/clockJob/ClockJobExtendedModule.js